<template>
  <div class="pop">
    <div class="teaching"
         :style="{backgroundImage:'url('+require('../../assets/images/upiTeaching/teach'+currentIndex+'.png')+')'}">
      <div class="tip" :class="'tip'+[currentIndex]" @click="nextPage">{{ $t('lang.upiTeaching.tip')[currentIndex][0] }}</div>
      <div class="tip" :class="'tip'+[currentIndex]+'-1'" @click="nextPage">{{ $t('lang.upiTeaching.tip')[currentIndex][1] }}</div>
      <div class="next" :class="'next'+currentIndex" @click="nextPage">{{ $t('lang.upiTeaching.next') }}</div>
      <div class="back" :class="'back'+currentIndex" @click="backPage" v-show="currentIndex>0">{{ $t('lang.upiTeaching.back') }}</div>
      <div class="skip" v-show="currentIndex!==3" @click="skipPage">{{ $t('lang.upiTeaching.skip') }}</div>
<!--      <div class="must" v-if="currentIndex===3">{{ $t('lang.upiTeaching.must') }}</div>-->
    </div>
  </div>
</template>

<script>
import {LogUtils} from '@/utils'

export default {
  name: 'UPITeaching',
  props: ['handleClose', 'finishUpiStudy'],
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      currentIndex: 0
    }
  },
  mounted () {
  },
  methods: {
    nextPage () {
      if (this.currentIndex === 0) {
        LogUtils.saveUserEvent('UpiGuide_Next', this.userInfo.UserId)
      }
      if (this.currentIndex < 3) {
        this.currentIndex++
      } else {
        this.finishUpiStudy()
      }
    },
    backPage () {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    skipPage () {
      if (this.currentIndex === 0) {
        LogUtils.saveUserEvent('UpiGuide_Skip', this.userInfo.UserId)
      }
      this.currentIndex = 3
    }
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 999;

  .teaching {
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    height: 205.555vw;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .must {
      position: absolute;
      top: 105.7vw;
      left: 11.15vw;
      width: 23vw;
      font-size: 17px;
      font-weight: 700;
      text-align: center;
      color: #E62828;
    }
    .skip {
      position: absolute;
      top: 190vw;
      left: 5.83vw;
      color: #CACACA;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      text-decoration: underline;
    }

    .tip {
      position: absolute;
      font-size: 3.611vw;
      text-align: center;
      color: #000;
      text-transform: capitalize;
      font-weight: 500;
      z-index: 999;
    }
    .tip0 {
      top: 25.8vw;
      left: 73vw;
      transform: translate(-50%);
      width: 52vw;
      border-radius: 0.5vw;
      //border: 1px solid red;
    }
    .tip0-1 {
      top: 135.5vw;
      left: 50vw;
      transform: translate(-50%);
      width: 85vw;
      border-radius: 0.5vw;
      //border: 1px solid red;
    }
    .tip1 {
      top: 124.5vw;
      left: 12.5vw;
      width: 73.5vw;
      border-radius: 0.5vw;
      //border: 1px solid red;
    }
    .tip2 {
      top: 134vw;
      left: 11.4vw;
      width: 75.5vw;
      border-radius: 0.5vw;
    }
    .tip3 {
      top: 121.2vw;
      left: 10.8vw;
      width: 80.7vw;
      border-radius: 0.5vw;
    }
    .tip3-1 {
      top: 29.2vw;
      left: 8.8vw;
      width: 82.7vw;
      border-radius: 0.5vw;
    }
    .back {
      position: absolute;
      font-size: 4.166vw;
      font-weight: 600;
      text-align: center;
      color: #fff;
    }
    .back1 {
      top: 139.25vw;
      left: 14vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }
    .back2 {
      top: 148.6vw;
      left: 14.6vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }
    .back3 {
      top: 105.35vw;
      left: 14.25vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }

    .next {
      position: absolute;
      font-size: 4.166vw;
      font-weight: 600;
      text-align: center;
      color: #000;
    }
    .next0 {
      top: 145.5vw;
      left: 31.4vw;
      width: 39.25vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.5vw;
    }
    .next1 {
      top: 139.25vw;
      left: 55vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }
    .next2 {
      top: 148.6vw;
      left: 55.35vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }
    .next3 {
      top: 105.35vw;
      left: 55vw;
      width: 31vw;
      height: 8.25vw;
      line-height: 8.25vw;
      border-radius: 0.8vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UPITeaching/index.vue